import verilog from "refractor/verilog";
export default verilog;